import React from 'react';
import MediaRender from './MediaRender';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {

  return (
    <MediaRender
      type="image"
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = "/assets/images/no_image.png"
      }}
      {...props}
    />
  );
}

export default Image;
